import React, { useState } from "react";
import {
  AppBar,
  Box,
  Button,
  Container,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
  IconButton,
} from "@mui/material";

import {
  KeyboardArrowDown,
  Download,
  Favorite,
  CardGiftcard,
  GitHub,
} from "@mui/icons-material";

const navigationItems = {
  Informasi: ["Panduan", "Pengembangan"],
  Tentang: ["Pengguna", "Fitur"],
  Dokumentasi: ["Plugins"],
};

export default function Navigation() {
  const [anchorEls, setAnchorEls] = useState({
    project: null,
    community: null,
    resources: null,
  });

  const handleOpenMenu = (event, section) => {
    setAnchorEls({ ...anchorEls, [section]: event.currentTarget });
  };

  const handleCloseMenu = (section) => {
    setAnchorEls({ ...anchorEls, [section]: null });
  };

  return (
    <>
      <Container
        maxWidth="lg"
        sx={{
          //position: 'sticky', // Sticky untuk tetap berada di atas
          top: 0,
          zIndex: 1000, // Prioritas tinggi agar di atas konten
          backgroundColor: "background.paper", // Latar belakang
          borderBottom: "1px solid #ddd", // Garis bawah
          //boxShadow: 1, // Shadow opsional
        }}
      >
        <Toolbar disableGutters>
          <Box
            component="img"
            src={process.env.PUBLIC_URL + "/static/images/logo/logobig.png"} // Ganti dengan jalur gambar Anda
            alt="BIG Logo"
            sx={{
              width: "40px",
              height: "40px",
              objectFit: "contain",
              marginRight: "8px",
            }}
          />
          <Typography
            variant="h6"
            sx={{
              flexGrow: 1,
              color: "primary.main",
              fontWeight: "bold",
              fontSize: "1.5rem",
            }}
          >
            GEOPORTAL PALAPA
          </Typography>

          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            {Object.entries(navigationItems).map(([section, items]) => (
              <React.Fragment key={section}>
                <Button
                  sx={{ color: "text.primary" }}
                  endIcon={<KeyboardArrowDown />}
                  onClick={(e) => handleOpenMenu(e, section)}
                >
                  {section.charAt(0).toUpperCase() + section.slice(1)}
                </Button>
                <Menu
                  anchorEl={anchorEls[section]}
                  open={Boolean(anchorEls[section])}
                  onClose={() => handleCloseMenu(section)}
                >
                  {items.map((item) => (
                    <MenuItem
                      key={item}
                      onClick={() => handleCloseMenu(section)}
                    >
                      {item}
                    </MenuItem>
                  ))}
                </Menu>
              </React.Fragment>
            ))}

            <Button
              startIcon={<GitHub />}
              sx={{ color: "text.primary" }}
              href="https://repo.big.go.id/emhayusa/geoportal-palapa-compose"
              target="_blank"
            >
              Akses Repo
            </Button>
          </Box>
        </Toolbar>
      </Container>

      {/* Spacer to prevent content overlap */}
      <Box sx={{ height: "48px" }} />
    </>
  );
}
